/*
 * Function that return the next focusable element from 'currentEle'
 * @param {jQuery} currentEle
 * @param {jQuery} [exclude] An optional param. A list of elements to ignore when searching the dom for focusable elements.
 * @returns {jQuery} The next focusable element in the dom, after currentEle
 */

const getNextFocusEle = function (currentEle, exclude) {
    let tabbables = $(':tabbable').filter(':visible');

    if (typeof exclude !== 'undefined' && exclude.length > 0) {
        tabbables = tabbables.not(exclude);
    }
    const nextTabbable = tabbables.eq(tabbables.index(currentEle) + 1);
    return nextTabbable.length ? nextTabbable : currentEle;
};

export default getNextFocusEle;
